import React, { Component } from "react"
import cs from 'classnames'
import WizardModalContent from "./shared/WizardModalContent"
import styles from './ClaimWizard.scss'
import i18n from 'lib/i18n'
import { disableRiskAndQualificationFields, updatedFormValue } from "./claimsWizardService"
import { CreatableSelectWrapper } from "./shared/WizardSelects/WizardReactSelect"
import { DatePicker } from 'components/shared/datePicker'


// variables out of module
const _ = i18n('claimWizard')


export default class ClaimWizardStepOne extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        const {
            formData, phoneNumberOptions, mobilePhoneOptions, emailOptions, productListOptions, selfManaging,
            onClaimDateHandler, handleProductChange, handleQualificationChange, riskOptionsList, qualificationOptionsList,
            accountNumberOptions, subQualificationOptionsList, isLegalAid, isExistingClaim, errors, handleSelfManagingChange, dispatch
        } = this.props
        const selfManagingOptions = [
            { value: 'true', label: _('Yes') },
            { value: 'false', label: _('No') },
        ]

        const hasInitialValue = formData.email.value.length === 0 && formData.mobileNumber.value.length === 0 && formData.phoneNumber.value.length === 0

        return (
            <WizardModalContent modalTitle={_('stepOneTitle')}>

                <form method="post" onSubmit={(ev) => ev.preventDefault()} className={styles.modalFormContent}
                    key={"claimWizardStepOneForm"}>
                    <div className={styles.sectionWrapper} key={"brokerSection"}>
                        {!isLegalAid && selfManaging &&
                            <div className={styles.formInputContainer} key={"selfManagingContainer"}>
                                <label className={styles.formLabel}>{_('selfManaging')} </label>
                                <div className={cs(styles.formInput, styles.formInputCreatableSelect)}>
                                    <CreatableSelectWrapper
                                        type="text"
                                        {...formData.selfManaging}
                                        options={selfManagingOptions}
                                        onChange={(value) => {
                                            handleSelfManagingChange(value.vale)
                                            updatedFormValue(value, formData.selfManaging, dispatch)
                                        }}
                                        name="selfManaging"
                                        isCreatableSelect={false}
                                        isDisabled={isExistingClaim}
                                    />
                                </div>
                            </div>
                        }
                        <div className={styles.formInputContainer} key={"brokerNameContainer"}>
                            <label className={styles.formLabel}>{_('brokerName')} </label>
                            <input
                                className={cs(styles.formInput, styles.formInputText)}
                                type="text"
                                ref="claimNumber"
                                name="claimNumber"
                                disabled={true}
                                {...formData.brokerName}
                            />
                        </div>
                        <div className={styles.formInputContainer} key={"claimNumberContainer"}>
                            <label className={styles.formLabel}>{_('claimNumber')} </label>
                            <input
                                className={cs(styles.formInput, styles.formInputText)}
                                type="text"
                                ref="claimNumber"
                                name="claimNumber"
                                disabled={true}
                                {...formData.claimNumber}
                            />
                        </div>

                        <div className={styles.formSeparator}></div>
                    </div>
                    <div className={styles.sectionWrapper} key={"clientSection"}>
                        <span className={styles.fillMostFieldsLabel}>{_('contactDetailFillInfosLabel')}</span>
                        <div className={styles.formInputContainer} key={"clientNameContainer"}>
                            <label className={styles.formLabel}>{_('clientName')} </label>
                            <input
                                className={cs(styles.formInput, styles.formInputText)}
                                type="text"
                                ref="clientName"
                                name="clientName"
                                disabled={true}
                                {...formData.clientName}
                            />
                        </div>
                        <div className={styles.formInputContainer} key={"phoneNumberContainer"}>
                            <label className={styles.formLabel}>{_('phoneNumber')} </label>
                            <div className={cs(styles.formInput, styles.formInputCreatableSelect)}>
                                <CreatableSelectWrapper
                                    type="text"
                                    {...formData.phoneNumber}
                                    options={phoneNumberOptions}
                                    onChange={(value) => updatedFormValue(value, formData.phoneNumber, dispatch)}
                                    name="phoneNumber"
                                    noOptionsLabel={_('phoneNumberNoOptions')}
                                    formatCreateLabel={_('newClaimPhoneNumber')}
                                    isClearable
                                    isCreatableSelect={true}
                                />
                            </div>
                        </div>
                        <div className={cs(styles.errorMessageContainer,
                            ((formData.phoneNumber.touched || formData.mobileNumber.touched || formData.email.touched) && errors.stepOne && errors.stepOne.phoneNumber) ? "" : styles.none
                        )}>
                            <div className={cs(styles.errorMessage, styles.textAlignLeft)}>
                                {errors.stepOne && errors.stepOne.phoneNumber}
                            </div>
                        </div>
                        <div className={styles.formInputContainer} key={"mobileNumberContainer"}>
                            <label className={styles.formLabel}>{_('mobileNumber')} </label>
                            <div className={cs(styles.formInput, styles.formInputCreatableSelect)}>
                                <CreatableSelectWrapper
                                    type="text"
                                    {...formData.mobileNumber}
                                    options={mobilePhoneOptions}
                                    onChange={(value) => updatedFormValue(value, formData.mobileNumber, dispatch)}
                                    name="mobileNumber"
                                    formatCreateLabel={_('newClaimPhoneNumber')}
                                    isClearable
                                    isCreatableSelect={true}

                                />
                            </div>
                        </div>
                        <div className={cs(styles.errorMessageContainer,
                            ((formData.mobileNumber.touched || formData.phoneNumber.touched || formData.email.touched) && errors.stepOne && errors.stepOne.mobileNumber) ? "" : styles.none
                        )}>
                            <div className={cs(styles.errorMessage, styles.textAlignLeft)}>
                                {errors.stepOne && errors.stepOne.mobileNumber}
                            </div>
                        </div>
                        <div className={styles.formInputContainer} key={"emailContainer"}>
                            <label className={styles.formLabel}>{_('email')} </label>
                            <div className={cs(styles.formInput, styles.formInputCreatableSelect)}>
                                <CreatableSelectWrapper
                                    type="text"
                                    {...formData.email}
                                    options={emailOptions}
                                    onChange={(value) => updatedFormValue(value, formData.email, dispatch)}
                                    formatCreateLabel={_('newClaimEmail')}
                                    name="email"
                                    isClearable
                                    isCreatableSelect={true}
                                />
                            </div>
                        </div>
                        <div className={cs(styles.errorMessageContainer,
                            (((formData.email.touched || formData.mobileNumber.touched || formData.phoneNumber.touched) && errors.stepOne && errors.stepOne.email) || hasInitialValue) ? "" : styles.none
                        )}>
                            <div className={cs(styles.errorMessage, styles.textAlignLeft)}>
                                {errors.stepOne && (errors.stepOne.email || errors.stepOne.phoneNumber || errors.stepOne.mobileNumber)}
                            </div>
                        </div>
                        <div className={styles.formInputContainer} key={"accountNumberContainer"}>
                            <label className={styles.formLabel}>{_('accountNumber')} </label>
                            <div className={cs(styles.formInput, styles.formInputCreatableSelect)}>
                                <CreatableSelectWrapper
                                    type="text"
                                    {...formData.accountNumber}
                                    options={accountNumberOptions}
                                    onChange={(value) => updatedFormValue(value, formData.accountNumber, dispatch)}
                                    formatCreateLabel={_('newClaimAccountNumber')}
                                    name="accountNumber"
                                    isClearable
                                    isCreatableSelect={false}
                                />
                            </div>
                        </div>
                        <div className={cs(styles.errorMessageContainer,
                            (formData.accountNumber.touched && errors.stepOne && errors.stepOne.accountNumber) ? "" : styles.none
                        )}>
                            <div className={cs(styles.errorMessage, styles.textAlignLeft)}>
                                {formData.accountNumber.touched && errors.stepOne && errors.stepOne.accountNumber}
                            </div>
                        </div>
                        {formData.accountNumber.value &&
                            <div className={styles.formInputContainer} key={"bakConfirmation"}>
                                <div className={cs(styles.formInput, styles.sizeExtraSmall)}>
                                    <input
                                        className={cs(styles.formInputCheckboxLeft)}
                                        type="checkBox"
                                        ref="claimNumber"
                                        name="claimNumber"
                                        {...formData.accountConfirmation}
                                    />
                                </div>
                                <label className={styles.formLabel}>{_('accountConfirmationLabel')} </label>

                            </div>
                        }
                        {formData.accountNumber.value &&
                            <div className={cs(styles.errorMessageContainer,
                                (formData.accountConfirmation.touched && errors.stepOne && errors.stepOne.accountConfirmation) ? "" : styles.none
                            )}>
                                <div className={cs(styles.errorMessage, styles.textAlignLeft)}>
                                    {formData.accountConfirmation.touched && errors.stepOne && errors.stepOne.accountConfirmation}
                                </div>
                            </div>
                        }
                        <div className={styles.formSeparator}></div>
                    </div>
                    <div className={styles.sectionWrapper} key={"claimSection"}>
                        <div className={styles.formInputContainer} key={"claimDateContainer"}>
                            <label className={styles.formLabel}>{_('claimDate')} </label>
                            <div className={cs(styles.formInput, styles.inputsForceRow)}>
                                <div className={cs(styles.formInput, styles.formInputCreatableSelect,
                                    styles.sizeXS, styles.first)}>
                                    <DatePicker
                                        {...formData.claimDate}
                                        onChange={(ev => {
                                            onClaimDateHandler(ev)
                                            formData.claimDate.onChange(ev)
                                        })}
                                        disabled={isExistingClaim}
                                    />
                                </div>
                                <div className={cs(styles.formLabel, styles.marginLeftS, styles.short1)}>{_('claimRefBrokerLabel')}</div>
                                <div className={cs(styles.formInput, styles.formInputCreatableSelect, styles.sizeXS, styles.shortMargin, styles.last)}>
                                    <input
                                        className={cs(styles.formInput, styles.formInputText)}
                                        type="text"
                                        ref="claimRefBroker"
                                        name="claimRefBroker"
                                        {...formData.claimRefBroker}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className={cs(styles.errorMessageContainer,
                            (formData.claimDate.touched && errors.stepOne && errors.stepOne.claimDate) ? "" : styles.none
                        )}>
                            <div className={cs(styles.errorMessage, styles.textAlignLeft)}>
                                {formData.claimDate.touched && errors.stepOne && errors.stepOne.claimDate}
                            </div>
                        </div>
                        <div className={styles.formInputContainer} key={"productContainer"}>
                            <label className={styles.formLabel}>{_('product')} </label>
                            <div className={cs(styles.formInput, styles.formInputCreatableSelect)}>
                                <CreatableSelectWrapper
                                    type="text"
                                    {...formData.productId}
                                    options={productListOptions}
                                    onChange={(value) => {
                                        handleProductChange(value)
                                        return updatedFormValue(value, formData.productId, dispatch)
                                    }}
                                    name="product"
                                    isCreatableSelect={false}
                                    isDisabled={isExistingClaim || !formData.claimDate.value}
                                />
                            </div>
                        </div>
                        <div className={cs(styles.errorMessageContainer,
                            (formData.productId.touched && errors.stepOne && errors.stepOne.productId) ? "" : styles.none
                        )}>
                            <div className={cs(styles.errorMessage, styles.textAlignLeft)}>
                                {formData.productId.touched && errors.stepOne && errors.stepOne.productId}
                            </div>
                        </div>
                        <div className={styles.formInputContainer} key={"riskContainer"}>
                            <label className={styles.formLabel}>{_('risk')} </label>
                            <div className={cs(styles.formInput, styles.formInputCreatableSelect)}>
                                <CreatableSelectWrapper
                                    type="text"
                                    {...formData.riskId}
                                    options={riskOptionsList}
                                    onChange={(value) => {
                                        updatedFormValue(value, formData.riskId, dispatch)
                                        updatedFormValue({ value: value.label }, formData.riskDescription, dispatch)
                                    }}
                                    isDisabled={isExistingClaim || disableRiskAndQualificationFields(formData.productId)}
                                    name="risk"
                                    isCreatableSelect={false}
                                />
                            </div>
                        </div>
                        <div className={cs(styles.errorMessageContainer,
                            (formData.riskId.touched && errors.stepOne && errors.stepOne.riskId) ? "" : styles.none
                        )}>
                            <div className={cs(styles.errorMessage, styles.textAlignLeft)}>
                                {formData.riskId.touched && errors.stepOne && errors.stepOne.riskId}
                            </div>
                        </div>
                        <div className={styles.formInputContainer} key={"qualificationContainer"}>
                            <label className={styles.formLabel}>{_('qualification')} </label>
                            <div className={cs(styles.formInput, styles.formInputCreatableSelect)}>
                                <CreatableSelectWrapper
                                    type="text"
                                    {...formData.qualificationNumber}
                                    options={qualificationOptionsList}
                                    onChange={(value) => {
                                        handleQualificationChange(value);
                                        updatedFormValue(value, formData.qualificationNumber, dispatch);
                                        updatedFormValue({ value: value.label }, formData.qualificationLabel, dispatch);
                                    }}
                                    isDisabled={isExistingClaim || disableRiskAndQualificationFields(formData.productId)}
                                    name="qualification"
                                    isCreatableSelect={false}
                                />
                            </div>
                        </div>

                        <div className={cs(styles.errorMessageContainer,
                            (formData.qualificationNumber.touched && errors.stepOne && errors.stepOne.qualificationNumber) ? "" : styles.none
                        )}>
                            <div className={cs(styles.errorMessage, styles.textAlignLeft)}>
                                {formData.qualificationNumber.touched && errors.stepOne && errors.stepOne.qualificationNumber}
                            </div>
                        </div>

                        {subQualificationOptionsList && subQualificationOptionsList.length > 0 &&
                            <div className={styles.formInputContainer} key={"subQualificationContainer"}>
                                <label className={styles.formLabel}>{_('subQualification')} </label>
                                <div className={cs(styles.formInput, styles.formInputCreatableSelect)}>
                                    <CreatableSelectWrapper
                                        type="text"
                                        {...formData.subQualificationNumber}
                                        options={subQualificationOptionsList}
                                        onChange={(value) => {
                                            return updatedFormValue(value, formData.subQualificationNumber, dispatch)
                                        }}
                                        isDisabled={isExistingClaim || disableRiskAndQualificationFields(formData.productId)}
                                        name="subQualification"
                                        isCreatableSelect={false}
                                    />
                                </div>
                            </div>
                        }

                        {subQualificationOptionsList && subQualificationOptionsList.length > 0 &&
                            <div className={cs(styles.errorMessageContainer,
                                (formData.subQualificationNumber.touched && errors.stepOne && errors.stepOne.subQualificationNumber) ? "" : styles.none
                            )}>
                                <div className={cs(styles.errorMessage, styles.textAlignLeft)}>
                                    {formData.subQualificationNumber.touched && errors.stepOne && errors.stepOne.subQualificationNumber}
                                </div>
                            </div>
                        }
                    </div>

                    {this.props.children}
                </form>
            </WizardModalContent >
        )
    }
} 


// WEBPACK FOOTER //
// ./components/ClaimsWizard/ClaimWizardStepOne.jsx